export const sideMenuWidth = 240;
